import { render } from "./detailAccount.vue?vue&type=template&id=c355ddd6&scoped=true"
import script from "./detailAccount.vue?vue&type=script&lang=js"
export * from "./detailAccount.vue?vue&type=script&lang=js"

import "./detailAccount.vue?vue&type=style&index=0&id=c355ddd6&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c355ddd6"]])

export default __exports__